import React from 'react';

import { getRequiredConfig } from '@klpkonsern/appconfig';
import { generateRouteParams } from '@klpkonsern/routing';

import { ActionButton, Block, Heading } from '@klp/design';
import { Paragraph } from '@klp/design/Typography/Typography/Paragraph';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

import type { Theme } from '@material-ui/core';
import { Grid } from '@material-ui/core';

import Image from '../assets/KLP_mann_datamaskin.png';

export interface ILevendeKontrakterParams {
    language?: string;
    autologin: boolean;
    hiddenNavbar: boolean;
    kundeNummer?: string;
}

const styles = (theme: Theme) => ({
    title: {
        fontFamily: theme.typography.fontFamily,
    },
    buttonsContainer: {
        display: 'flex',
    },
    image: {
        '& > img': {
            width: '70%',
            minHeight: '1px', // IE11 hack
            maxWidth: '70%',
        },
    },
    alertContainer: {
        backgroundColor: theme.palette.secondary.veryLight,
        border: '1px solid transparent',
        borderColor: theme.palette.secondary.main,
    },
    alertIcon: {
        width: '1em',
        height: '1em',
        fontSize: '2em',
    },
});

export const LevendeKontrakter: React.FC = () => {
    const classes = useKlpStyles({}, styles);

    const newTabParams: ILevendeKontrakterParams = {
        autologin: true,
        hiddenNavbar: false,
    };

    const url = getRequiredConfig('WEBAPP_CONTRACT_FRAME_URL').concat(
        generateRouteParams(newTabParams),
    );

    const openLEKO = () => {
        window.open(url, 'Contracts');
    };

    return (
        <Grid container={true} direction="row" justifyContent="flex-start">
            <Grid item={true} md={true} lg={true}>
                <Heading
                    klpHeadingLevel="FOUR"
                    klpColor="dark"
                    translation="contractFrame.externalFrame.title"
                    data-cy="LevendeKontrakter__Title"
                />
                <Block paddingTop="compact">
                    <Paragraph
                        translation="contractFrame.externalFrame.description"
                        data-cy="LevendeKontrakter__Description"
                    />
                </Block>
                <Block paddingTop="compact">
                    <ActionButton
                        actionType="external"
                        translation="contractFrame.externalFrame.actionButton"
                        onClick={openLEKO}
                        data-cy="ErrorNotification__MainActionButton"
                    />
                </Block>
            </Grid>
            <Grid item={true} md={12} lg={6}>
                <Block className={classes.image} paddingTop="fat">
                    <img src={Image} alt="Mann datamaskin image" />
                </Block>
            </Grid>
        </Grid>
    );
};
